import { SessionTutorialSpotlight } from '@/features/session-tutorial/SessionTutorialSpotlight';
import { SessionTutorialTip } from '@/features/session-tutorial/SessionTutorialTip';
import type { SessionTutorialOverlayProps } from '@/features/session-tutorial/sessionTutorial.types';
import { Popover, PopoverAnchor } from '@careflux/primitives';
import { useMemo } from 'react';

/** The one tip on the page: a dimmed backdrop with the target cut out, and the tip beside it. */
export const SessionTutorialOverlay = ({ target, ...tip }: SessionTutorialOverlayProps) => {
  const anchorRef = useMemo(() => ({ current: target }), [target]);

  return (
    <>
      <SessionTutorialSpotlight target={target} />
      <Popover open>
        <PopoverAnchor virtualRef={anchorRef} />
        <SessionTutorialTip {...tip} />
      </Popover>
    </>
  );
};
